export const BILLING_DISCOUNT_MODE_FIXED_V816 = 'fixed';
export const BILLING_DISCOUNT_MODE_TIERED_V816 = 'tiered';
export const BILLING_DISCOUNT_EFFECTIVE_CURRENT_V816 = 'current_cycle';
export const BILLING_DISCOUNT_EFFECTIVE_NEXT_V816 = 'next_cycle';
export const BILLING_DISCOUNT_EFFECTIVE_NOW_V1022 = 'immediate';

export const payablePercentToBasisPointsV816 = (value) => {
  const normalized = String(value).trim();
  if (!/^\d{1,3}(\.\d{1,2})?$/.test(normalized)) return null;
  const [whole, fraction = ''] = normalized.split('.');
  const basisPoints = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  if (
    !Number.isInteger(basisPoints) ||
    basisPoints < 1 ||
    basisPoints > 10000
  ) {
    return null;
  }
  return basisPoints;
};

export const scheduleModeV816 = (schedule) => {
  if (schedule?.mode === BILLING_DISCOUNT_MODE_FIXED_V816) {
    return BILLING_DISCOUNT_MODE_FIXED_V816;
  }
  const tierCount = Number(
    schedule?.tier_count ?? schedule?.tiers?.length ?? 0
  );
  return tierCount === 1
    ? BILLING_DISCOUNT_MODE_FIXED_V816
    : BILLING_DISCOUNT_MODE_TIERED_V816;
};

export const buildDiscountProgramRequestV816 = ({
  initialScheduleId,
  ongoingScheduleId,
  effectiveMode,
  trialEnabled,
  trialCycles,
  idempotencyKey,
  expectedAssignmentId,
  expectedRevision,
}) => {
  const cycles = trialEnabled ? Number(trialCycles) : 0;
  const mode =
    effectiveMode === BILLING_DISCOUNT_EFFECTIVE_CURRENT_V816
      ? BILLING_DISCOUNT_EFFECTIVE_NOW_V1022
      : effectiveMode;
  if (
    !initialScheduleId ||
    !idempotencyKey ||
    ![
      BILLING_DISCOUNT_EFFECTIVE_CURRENT_V816,
      BILLING_DISCOUNT_EFFECTIVE_NEXT_V816,
      BILLING_DISCOUNT_EFFECTIVE_NOW_V1022,
    ].includes(mode) ||
    !Number.isInteger(cycles) ||
    cycles < 0 ||
    cycles > 24 ||
    (trialEnabled && (!ongoingScheduleId || cycles < 1)) ||
    (mode === BILLING_DISCOUNT_EFFECTIVE_NOW_V1022 &&
      (!/^\d+$/.test(String(expectedAssignmentId)) ||
        !Number.isSafeInteger(expectedRevision) ||
        expectedRevision < 0))
  ) {
    return null;
  }
  return {
    initial_schedule_id: String(initialScheduleId),
    ongoing_schedule_id: trialEnabled ? String(ongoingScheduleId) : '',
    effective_mode: mode,
    trial_cycles: cycles,
    idempotency_key: idempotencyKey,
    ...(mode === BILLING_DISCOUNT_EFFECTIVE_NOW_V1022
      ? {
          expected_assignment_id: String(expectedAssignmentId),
          expected_revision: expectedRevision,
        }
      : {}),
  };
};
